import React from 'react';
import background from "../../assets/background.png";
import Typewriter from 'typewriter-effect';
import { FiDownload } from 'react-icons/fi'
const Banner = () => {
    return (
        <section>
            <div className="hero min-h-screen" style={{ backgroundImage: `url(${background})` }}>
                <div className="hero-overlay bg-opacity-60"></div>
                <div className="hero-content text-center text-neutral-content">
                    <div>
                        <h1 data-aos="fade-right" data-aos-duration="3000" className="mb-5 text-5xl font-bold">Here, I'm Mahabubul Islam</h1>
                        <div data-aos="fade-left" data-aos-duration="3000" data-aos-delay="50" className="mb-5">I'm passionate
                            <span className='text-center text-teal-500'>
                                <Typewriter
                                    options={{
                                        strings: [
                                            'Web Developer',
                                            'Frontend Developer',
                                            'MERN Developer',
                                            'React Developer',
                                            'Junior Developer'],
                                        autoStart: true,
                                        loop: true,
                                    }}
                                />
                            </span>
                        </div>
                        <div className='flex flex-col md:flex-row items-center justify-center'>
                            <a href='/#contact' className="btn  m-2 bg-gradient-to-r from-teal-500 to-blue-500 hover:from-blue-500 hover:to-teal-500 duration-300 border-0">Contact me</a>
                            <a href="https://drive.google.com/uc?id=18mOjVQktP_xjZIDuU4YG-PI9Qwd1O3CZ&export=download" download className="btn m-2 border-0 bg-gradient-to-r from-teal-500  to-blue-500 hover:from-blue-500 hover:to-teal-500 duration-300">Download Resume <FiDownload className='font-bold text-xl ml-2'></FiDownload></a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Banner;